// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".UserTooltip-cls1___6897b915e676fd04c59{/*!*/}.UserTooltip-cls2___1b44bc41ffc108ed857{height:32px;box-shadow:0px 2px 4px rgba(0,0,0,.1)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "UserTooltip-cls1___6897b915e676fd04c59",
	"cls2": "UserTooltip-cls2___1b44bc41ffc108ed857 UserTooltip-cls1___6897b915e676fd04c59"
};
export default ___CSS_LOADER_EXPORT___;
